module.exports = "<!-- * PAGE-CARDS * -->\n<router-outlet></router-outlet>"